import React from 'react';
import styled from 'styled-components';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../model/hooks';
import { SecondaryButton } from '../../components';
export const AdminHome = () => {
    const { t } = useTranslation();
    const history = useHistory();
    const location = useLocation();
    const nowPath = location.pathname;
    const { logout } = useAuth();
    const onClickToApplyList = () => {
        history.push(`${nowPath}/apply_list`);
    };
    const onClickToClinicList = () => {
        history.push(`${nowPath}/clinic_list`);
    };
    const onClickLogout = async () => {
        await logout();
        history.push('/');
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(SContainer, null,
            React.createElement(SButtonArea, null,
                React.createElement(SecondaryButton, { fullWidth: true, onClick: onClickToApplyList }, t('申請一覧')),
                React.createElement("div", { style: { margin: '8px 0 8px 0' } },
                    React.createElement(SecondaryButton, { fullWidth: true, onClick: onClickToClinicList }, t('クリニック一覧'))),
                React.createElement("div", { style: { margin: '8px 0 8px 0' } },
                    React.createElement(SecondaryButton, { fullWidth: true, onClick: onClickLogout }, t('ログアウト')))))));
};
const SContainer = styled.div `
  padding-top: 96px;
  display: flex;
  justify-content: center;
`;
const SButtonArea = styled.div `
  width: 200px;
`;
